/* eslint-disable react/require-default-props,react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import CSSModules from 'react-css-modules';
import isEmpty from 'lodash/isEmpty';

import styles from './index.styl';

const Range = ({ scale, selected }) => {
  const items = [];

  for (let i = scale.minValue; i <= scale.maxValue; i++) {
    items.push(i);
  }

  if (isEmpty(items)) return null;

  return selected && selected === '-' ? (
    <span>{selected}</span>
  ) : (
    <ul styleName="root">
      {items.map((item, i) => {
        const isColored = +item <= +selected;
        const isSelected = +item === +selected;

        return (
          <li
            key={i}
            styleName={classNames('cell', {
              'cell--start': i === 0,
              'cell--colored': isColored,
              'cell--selected': isSelected,
            })}
          >
            <span styleName="mark">{item}</span>
          </li>
        );
      })}
    </ul>
  );
};

Range.propTypes = {
  scale: PropTypes.shape({
    minValue: PropTypes.number,
    maxValue: PropTypes.number,
  }),
  selected: PropTypes.string,
};

export default CSSModules(Range, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/common/Range/index.jsx